import {
  MappedPanelError,
  mapPanelError,
  PanelErrorRoute,
} from "../panelErrors";
import { AccountCashFormValues } from "./types";

export type AccountCashErrorField = keyof AccountCashFormValues;

export type MappedAccountCashError = MappedPanelError<AccountCashErrorField>;

// Shorter than holdingTradeActionErrors' table: this form has no position/quantity/instrument, so messages about those fall through to the banner.
const ROUTES: readonly PanelErrorRoute<AccountCashErrorField>[] = [
  ["Trade date", "date"],
  ["Effective date ", "date"],
  ["Trade amount", "amountEur"],
  ["Amount ", "amountEur"],
  ["Direction ", "direction"],
  ["Tax ", "taxWithheld"],
];

export const mapAccountCashError = (
  messages: string[],
): MappedAccountCashError => mapPanelError(messages, ROUTES);
